import { DataGrid, DataGridProps } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { common } from "../../i18n";
import { CustomPagination } from "./CustomPagination";
import { thTHGrid } from "./thTH";

export const AppDataGrid = ({
  slots,
  localeText,
  sx,
  ...props
}: DataGridProps) => {
  const { t, i18n } = useTranslation([common], { nsMode: "fallback" });

  return (
    <DataGrid
      disableRowSelectionOnClick
      disableColumnFilter
      disableColumnSelector
      disableDensitySelector
      disableColumnMenu
      localeText={{
        ...(i18n.language === "th" ? thTHGrid : {}),
        noRowsLabel: t("noRowsLabel"),
        noResultsOverlayLabel: t("noResultsOverlayLabel"),
        toolbarQuickFilterPlaceholder: `${t("search")}...`,
        ...localeText,
      }}
      slots={{ pagination: CustomPagination, ...slots }}
      sx={[
        {
          ".MuiDataGrid-columnHeader .MuiDataGrid-columnSeparator": {
            display: "none",
          },
          "& .MuiDataGrid-row": {
            cursor: "pointer",
          },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...props}
    />
  );
};
